export default "__VITE_ASSET__bpx8QfLq__"